import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Think of HostJane like a free hotel. Listings are our rooms for Buyers and Sellers to work together. If there's a fight in a room, we're fair about finding out what has happened. We want to resolve any problem fairly to both Buyer and Seller.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      